module.exports = __webpack_public_path__ + "img/ic_gift_nor.5762f231.svg";